import {useEffect} from 'react'
import {useLocation} from 'react-router'
import {DrawerComponent} from '../../../assets/ts/components'
import {WithChildren} from '../../../helpers'

const Content = ({children}: WithChildren) => {
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <div id='kt_app_content' className='flex-1'>
      {children}
    </div>
  )
}

export {Content}
